import React from 'react';
import { Row, Button } from 'antd';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { safeExtractFromObject } from '../../helpers/helpers';

export default function CustomExportFilterDropdownFooter({
  onReset,
  onApply,
  resetDisabled = false,
}) {
  const settings = useSelector((state) => safeExtractFromObject(state, 'settings.company.settings'));
  const hasRedesign = settings?.uxRedesignPt1;
  const className = hasRedesign ? 'button-redesign-primary' : '';
  return (
    <Row style={{ padding: '7px 8px 7px 3px' }} justify="space-between">
      <Button
        size="small"
        disabled={resetDisabled}
        type="text"
        onClick={onReset}
      >
        Reset
      </Button>
      <Button
        size="small"
        type="primary"
        onClick={onApply}
        className={className}
      >
        OK
      </Button>
    </Row>
  );
}

CustomExportFilterDropdownFooter.propTypes = {
  onReset: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
  resetDisabled: PropTypes.bool,
};

CustomExportFilterDropdownFooter.defaultProps = {
  resetDisabled: false,
};
